module.exports = __webpack_public_path__ + "static/img/pat.f.aa6c7c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/pat.f.jpg
// module id = 558
// module chunks = 382